<div [class]="skinName">
    @if(uId && !restrictedUser && plansLength){
    <div class="header_section" >
        <div [ngClass]="{'adjust-margin': profilesEnabled && page === 'account'}" class="join-now-block">
    
            <!-- when plans length is more than 1 -->
            @if( plansLength > 1){
            <span id="info-text">
                <span>{{configService.localeKeys?.acc_choose_plan_notif}}</span>
                <span>{{(configService.localeKeys?.pymnt_popup_part1 || 'Starting from') + ' '}}</span>
                <span>{{planService.planDetail}}</span>
            </span>}
            @if(plansLength > 1){
            <button  class="join-now-btn"  (click)="showPlan();openPaymentPopUp('#open-choose-plan')">
                <span>{{configService.localeKeys?.['plans.choose_plan.text'] || 'Choose Plan'}}</span>
            </button>
            }
            <!-- when plans length is 1 -->
            @if(plansLength === 1){
            <span  (click)="showPlan();openPaymentPopUp('#open-choose-plan')" class="single-plan-title cursor-pointer">{{ planService?.planText }}</span>
            }
        </div>
    </div>}
    <!-- payment popup -->
    @if(uId && !restrictedUser && plansLength){
    <div  id="open-choose-plan" class="uk-flex-top acc-modal" uk-modal="esc-close: false; bg-close: false;">
        <div class="uk-modal-dialog uk-modal-body uk-margin-auto-vertical pay-dialog">
            <button class="uk-modal-close-default uk-close-large" type="button" id="close-event" uk-close (click)="onPaymentPopupClose()"></button>
            <!-- payment popup when no subscription -->
            @if(!hidePlans){
            <app-model-payment  [page]="'contentDetail'" #ModelPayment></app-model-payment>
            }
        </div>
    </div>}

</div>
